module.exports = __webpack_public_path__ + "static/img/meet-our-executive-team_2.0eae40b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/meet-our-executive-team_2.png
// module id = BLNp
// module chunks = 0